import { fetchAuthSession, fetchUserAttributes } from 'aws-amplify/auth';
import { setUserDetail, setAuthLoading } from '../store/authSlice';
import { fetchCapabilitiesSuccess, fetchCapabilitiesRequest } from '../store/capabilitiesSlice';
import { getCapabilitiesFromStorage } from './capabilitiesStorage';
import { saveAuthToStorage } from './authStorageHelper';

const toBoolean = (value) => value === true || value === 'true' || value === '1';

export const updateUserInRedux = async (dispatch, shouldPollCapabilities = false) => {
  try {
    const { tokens } = await fetchAuthSession({ forceRefresh: shouldPollCapabilities });

    let attrs = {
      email: tokens?.idToken?.payload?.email,
      given_name: tokens?.idToken?.payload?.given_name,
      family_name: tokens?.idToken?.payload?.family_name,
      phone_number: tokens?.idToken?.payload?.phone_number,
      phone_number_verified: tokens?.idToken?.payload?.phone_number_verified,
      sub: tokens?.idToken?.payload?.sub,
      'custom:companyId': tokens?.idToken?.payload?.['custom:companyId'],
    };

    const isOAuthUser = tokens?.idToken?.payload?.identities?.some(
      (identity) => identity.providerName && identity.providerName !== 'providerName'
    );

    if (!isOAuthUser) {
      try {
        const fullAttrs = await fetchUserAttributes();
        attrs = {
          ...attrs, 
          ...fullAttrs,
        };
      } catch (attrError) {
        // User attributes not available via OAuth
      }
    }

    const userDetail = {
      email: attrs.email,
      firstName: attrs.given_name,
      lastName: attrs.family_name,
      companyId: attrs['custom:companyId'],
      phoneNumber: attrs.phone_number,
      phoneNumberVerified: toBoolean(attrs.phone_number_verified),
      userId: attrs.sub,
      tokens: {
        accessToken: tokens?.accessToken?.toString(),
        idToken: tokens?.idToken?.toString(),
      },
    };

    dispatch(setUserDetail(userDetail));
    saveAuthToStorage(userDetail);

    if (attrs['custom:companyId']) {
      const cachedCapabilities = getCapabilitiesFromStorage();
      if (cachedCapabilities) {
        dispatch(fetchCapabilitiesSuccess(cachedCapabilities));
      } else {
        dispatch(fetchCapabilitiesRequest({ shouldPoll: shouldPollCapabilities }));
      }
    }

    dispatch(setAuthLoading(false));
  } catch (err) {
    dispatch(setAuthLoading(false));
  }
};
